/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SelectedPrintingsDto
 */
export interface SelectedPrintingsDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof SelectedPrintingsDto
     */
    selectedIds?: Array<number> | null;
}

/**
 * Check if a given object implements the SelectedPrintingsDto interface.
 */
export function instanceOfSelectedPrintingsDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SelectedPrintingsDtoFromJSON(json: any): SelectedPrintingsDto {
    return SelectedPrintingsDtoFromJSONTyped(json, false);
}

export function SelectedPrintingsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SelectedPrintingsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'selectedIds': !exists(json, 'selectedIds') ? undefined : json['selectedIds'],
    };
}

export function SelectedPrintingsDtoToJSON(value?: SelectedPrintingsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'selectedIds': value.selectedIds,
    };
}

